import React from 'react'
import Styles from './WeekPayment.module.css'

export default class WeekPayment extends React.Component {
    render() {
        return (
            <section className={Styles.week}>
                {this.props.week.employees.map((employee, key) => {
                    return <Employee 
                    employee={employee} 
                    key={key} 
                    week={this.props.week.weekAndYear}
                    status={this.props.status} />
                })}
            </section>
        )
    }
}

class Employee extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tableVisible: false,
        }
    }
    toggleTable = () => {
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }
    renderFrambuesaTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h1 className={Styles.title}>Pisca Frambuesa</h1>
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>S/T-S</th>
                            <th>Botes</th>
                            {/*<th>Precio</th> 
                            //<th>Total</th>*/}
                        </tr>
                        {activities.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.fecha}</td>
                                <td>{activity.areaHecha}</td>
                                <td>{+(activity.trabajoHecho).toFixed(1)}</td>
                                {/*<td>{`$${+(activity.precio / activity.trabajoHecho).toFixed(1)}`}</td>
                                <td>{`$${activity.precio}`}</td>*/}
                            </tr>
                        )}
                    </tbody></table>
                </div>
            </>
        )
    }
    renderZarzamoraTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h1 className={Styles.title}>Pisca Zarzamora</h1>
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>S/T-S</th>
                            <th>Medios Botes</th>
                            {/*<th>Precio</th>
                            <th>Total</th>*/}
                        </tr>
                        {activities.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.fecha}</td>
                                <td>{activity.areaHecha}</td>
                                <td>{+(activity.totalCajas * 4).toFixed(1)}</td>
                                {/*<td>{`$${+(activity.cajas6Precio / 4).toFixed(1)}`}</td>
                                <td>{`$${activity.precio}`}</td>*/}
                            </tr>
                        )}
                    </tbody></table>
                </div>
            </>
        )
    }
    renderPorDiaTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h1 className={Styles.title}>Por Dia</h1>
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>Concepto</th>
                            <th>Descripcion</th>
                            <th>S/T-S</th>
                            <th>Cantidad</th>
                            {/*<th>Precio U.</th>
                            <th>Total</th>*/}
                        </tr>

                        {
                            activities.map((activity, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{activity.fecha}</td>
                                        <td>{activity.actividad}</td>
                                        <td>{activity.descripcion}</td>
                                        <td>{activity.areaHecha}</td>
                                        <td>{`${Number(activity.trabajoHecho).toFixed(2)} ${activity.unidades || ''}`}</td>
                                        {/*
                                        <td>{`${Number(activity.precio / activity.trabajoHecho).toFixed(2)}$`}</td>
                                        <td>{`${activity.precio.toFixed(2)}$`}</td>
                                        */}
                                    </tr>
                                )
                            })
                        }

                    </tbody></table>
                </div>
            </>
        )
    }
    renderDestajoTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h1 className={Styles.title}>Destajo</h1>
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>Concepto</th>
                            <th>Descripcion</th>
                            <th>S/T-S</th>
                            <th>Cantidad</th>
                            {/*<th>Precio U.</th>
                            <th>Total</th>*/}
                        </tr>

                        {
                            activities.map((activity, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{activity.fecha}</td>
                                        <td>{activity.actividad}</td>
                                        <td>{activity.descripcion}</td>
                                        <td>{activity.areaHecha}</td>
                                        <td>{`${Number(activity.trabajoHecho).toFixed(2)} ${activity.unidades || ''}`}</td>
                                        {/*
                                        <td>{`${Number(activity.precio / activity.trabajoHecho).toFixed(2)}$`}</td>
                                        <td>{`${activity.precio.toFixed(2)}$`}</td>
                                        */}
                                    </tr>
                                )
                            })
                        }

                    </tbody></table>
                </div>
            </>
        )
    }
    render() {
        return (
            <div className={Styles.employee}>
                <div className={Styles.row} onClick={this.toggleTable}>
                    <p>{`Semana ${this.props.week}`}</p>
                    <p>{/*`Total: $${this.props.employee.salary.toFixed(2)}`*/}</p>
                </div>
                {
                    this.state.tableVisible
                        ? this.props.employee.activitiesDestajo.length > 0
                            ? this.renderDestajoTable(this.props.employee.activitiesDestajo)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.employee.activitiesDia.length > 0
                            ? this.renderPorDiaTable(this.props.employee.activitiesDia)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.employee.harvestFrambuesa.length > 0
                            ? this.renderFrambuesaTable(this.props.employee.harvestFrambuesa)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.employee.harvestZarzamora.length > 0
                            ? this.renderZarzamoraTable(this.props.employee.harvestZarzamora)
                            : null
                        : null
                }
            </div>
        )
    }
}